import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import apiService from "../../../Services/apiServices";
import { useToasts } from "react-toast-notifications";
import Search from "../../../PageComponents/Search/Search";
import Switch from "react-switch";
import globals from "../../../Services/globals";
import { confirmAlert } from "react-confirm-alert";
import helper from "../../../Services/helper";
import calculate from "../../../Services/calculate";
import Pagination from "../../../PageComponents/UI/Pagination/Pagination";
import SelectByGroup from './../../../PageComponents/UI/Inputs/SelectByGroup'
import ExcelExport from "../../../PageComponents/Excel/ExcelExport";
import Print from "../../../PageComponents/Print/Print";
import { formatData as incFormat } from "../../exportFunctions/exportFunction";
import XLSX from 'xlsx-js-style';


function BalanceSheet(props) {



  const { addToast } = useToasts();
  const excelExportRef = useRef();
  const [mainData, setMainData] = useState([]);
  const [dataForPrint, setDataForPrint] = useState([]);
  const [filterPrintData, setFilterPrintData] = useState([]);
  const [isPositive, setIsPositive] = useState(false);
  const [searchParams, setSearchParams] = useState({ projectId : 0, branchId: 0, includeStartDate : true, includeEndDate: true});
  const [projects, setProjects] = useState([]);
  const [branches, setBranches] = useState([]);
  const [showProgress, setShowProgress] = useState(false);
  const searchObj = { CompanyBranch: 0, PurchaseType: -1 , StartDate: helper().formatDate(searchParams?.startDate,'MM-dd-yyyy') ,  EndDate: helper().formatDate(searchParams?.endDate,'MM-dd-yyyy')}
  const printRef = useRef();
  const [settings, setSettings] = useState();

  

  ///const [startDate, setStartDate] = useState(new Date());

  useEffect(() => {
    getDates();
    getBranches();
    getProjects();
    setIsPositive(false);
    globals().getSettings().then(r => { if (r) setSettings(r); });
  }, [])
  
   useEffect(() => {
    if(isPositive === true){
     setFilterPrintData(dataForPrint)
    }else{
    let filteredArray = dataForPrint.filter(obj => obj.listItem != true);
    setFilterPrintData(filteredArray);
    }

  }, [dataForPrint,isPositive])

  const exportToExcel = () => {
    let rows = [];
    let styles = []; // track row types for styling

    let currPeriod = searchParams.startDate && searchParams.endDate ? helper().formatDate(searchParams.startDate) + ' - ' + helper().formatDate(searchParams.endDate) : 'Viti Aktual';
    let prevPeriod = searchParams.prevStartDate && searchParams.prevEndDate ? helper().formatDate(searchParams.prevStartDate) + ' - ' + helper().formatDate(searchParams.prevEndDate) : 'Viti Paraprak';

    // Company info
    let companyName = settings?.companyName || '';
    let fiscalNumber = settings?.fiscalNumber || '';
    let address = settings?.address || '';
    rows.push([`${companyName}  |  Nr. Fiskal: ${fiscalNumber}  |  ${address}`, '', '']);
    styles.push('companyInfo');
    rows.push(['Bilanci i Gjendjes', '', '']);
    styles.push('reportTitle');
    rows.push(['', '', '']);
    styles.push('empty');

    // Header
    rows.push(['Pershkrimi', currPeriod, prevPeriod]);
    styles.push('header');

    mainData.forEach(main => {
      // Klasa kryesore
      rows.push([main.name, '', '']);
      styles.push('class');

      if (main.subClasses) {
        main.subClasses.forEach(sub => {
          // Nen-klasa
          rows.push(['  ' + sub.name, '', '']);
          styles.push('subclass');

          sub.groups.forEach(g => {
            let cv = typeof g.currentYearValue === 'string' ? parseFloat(g.currentYearValue.replace(/,/g, '')) : (g.currentYearValue || 0);
            let pv = typeof g.previousYearValue === 'string' ? parseFloat(g.previousYearValue.replace(/,/g, '')) : (g.previousYearValue || 0);
            rows.push(['    ' + g.name, isNaN(cv) ? 0 : cv, isNaN(pv) ? 0 : pv]);
            styles.push('group');

            if (isPositive && g.groupsInfo) {
              g.groupsInfo.forEach(gr => {
                rows.push(['      ' + gr.accName, gr.grValue || 0, gr.prevGrValue || 0]);
                styles.push('detail');
              });
            }
          });

          let scv = typeof sub.currentYearValue === 'string' ? parseFloat(sub.currentYearValue.replace(/,/g, '')) : (sub.currentYearValue || 0);
          let spv = typeof sub.previousYearValue === 'string' ? parseFloat(sub.previousYearValue.replace(/,/g, '')) : (sub.previousYearValue || 0);
          rows.push(['  Totali ' + sub.name, isNaN(scv) ? 0 : scv, isNaN(spv) ? 0 : spv]);
          styles.push('subtotal');
        });
      }

      let mcv = typeof main.currentYearValue === 'string' ? parseFloat(main.currentYearValue.replace(/,/g, '')) : (main.currentYearValue || 0);
      let mpv = typeof main.previousYearValue === 'string' ? parseFloat(main.previousYearValue.replace(/,/g, '')) : (main.previousYearValue || 0);
      rows.push(['TOTALI ' + main.name.toUpperCase(), isNaN(mcv) ? 0 : mcv, isNaN(mpv) ? 0 : mpv]);
      styles.push('total');

      // Rresht bosh mes klasave
      rows.push(['', '', '']);
      styles.push('empty');
    });

    // Detyrime + Ekuitet
    if (mainData.length === 3) {
      let liabPlusEquity = (mainData[1]?.rawCurrentYearValue || 0) + (mainData[2]?.rawCurrentYearValue || 0);
      let prevLiabPlusEquity = (mainData[1]?.rawPreviousYearValue || 0) + (mainData[2]?.rawPreviousYearValue || 0);
      rows.push(['DETYRIMET + EKUITETI', liabPlusEquity, prevLiabPlusEquity]);
      styles.push('total');

      let diff = parseFloat(((mainData[0]?.rawCurrentYearValue || 0) - liabPlusEquity).toFixed(2));
      let prevDiff = parseFloat(((mainData[0]?.rawPreviousYearValue || 0) - prevLiabPlusEquity).toFixed(2));
      rows.push(['DIFERENCA', diff, prevDiff]);
      styles.push(Math.abs(diff) < 0.01 ? 'balanced' : 'unbalanced');
    }

    const ws = XLSX.utils.aoa_to_sheet(rows);

    // Column widths
    ws['!cols'] = [{ wch: 48 }, { wch: 22 }, { wch: 22 }];

    // Style definitions
    const borderThin = { top: {style:'thin', color:{rgb:'CCCCCC'}}, bottom: {style:'thin', color:{rgb:'CCCCCC'}}, left: {style:'thin', color:{rgb:'CCCCCC'}}, right: {style:'thin', color:{rgb:'CCCCCC'}} };
    const borderThick = { top: {style:'medium', color:{rgb:'4E73DF'}}, bottom: {style:'medium', color:{rgb:'4E73DF'}}, left: {style:'thin', color:{rgb:'CCCCCC'}}, right: {style:'thin', color:{rgb:'CCCCCC'}} };
    const numFmt = '#,##0.00';

    const styleMap = {
      companyInfo:    { font: {bold:true, sz:13, color:{rgb:'1B2A4A'}}, alignment: {vertical:'center'} },
      companyInfoNum: { font: {bold:true, sz:13, color:{rgb:'1B2A4A'}}, alignment: {vertical:'center'} },
      reportTitle:    { font: {bold:true, sz:12, color:{rgb:'4E73DF'}}, alignment: {vertical:'center'} },
      reportTitleNum: { font: {bold:true, sz:12, color:{rgb:'4E73DF'}}, alignment: {vertical:'center'} },
      header:     { font: {bold:true, color:{rgb:'FFFFFF'}, sz:12}, fill: {fgColor:{rgb:'1B2A4A'}}, alignment: {vertical:'center'}, border: borderThin },
      headerNum:  { font: {bold:true, color:{rgb:'FFFFFF'}, sz:12}, fill: {fgColor:{rgb:'1B2A4A'}}, alignment: {vertical:'center', horizontal:'right'}, border: borderThin },
      class:      { font: {bold:true, color:{rgb:'1A3E72'}, sz:12}, fill: {fgColor:{rgb:'D6E4F0'}}, border: borderThin },
      subclass:   { font: {bold:true, color:{rgb:'222222'}, sz:11}, fill: {fgColor:{rgb:'E9EDF5'}}, border: borderThin },
      group:      { font: {sz:10, color:{rgb:'111111'}}, border: borderThin, alignment: {indent:2} },
      groupNum:   { font: {sz:10, color:{rgb:'111111'}, bold:true}, border: borderThin, alignment: {horizontal:'right'}, numFmt: numFmt },
      detail:     { font: {sz:9, color:{rgb:'555555'}, italic:true}, fill: {fgColor:{rgb:'F5F6FA'}}, border: borderThin, alignment: {indent:4} },
      detailNum:  { font: {sz:9, color:{rgb:'555555'}, italic:true}, fill: {fgColor:{rgb:'F5F6FA'}}, border: borderThin, alignment: {horizontal:'right'}, numFmt: numFmt },
      subtotal:   { font: {bold:true, sz:10, color:{rgb:'111111'}}, fill: {fgColor:{rgb:'DCE3F0'}}, border: {top:{style:'medium', color:{rgb:'888888'}}, bottom:{style:'thin', color:{rgb:'CCCCCC'}}, left:{style:'thin', color:{rgb:'CCCCCC'}}, right:{style:'thin', color:{rgb:'CCCCCC'}}}, alignment: {indent:1} },
      subtotalNum:{ font: {bold:true, sz:10, color:{rgb:'111111'}}, fill: {fgColor:{rgb:'DCE3F0'}}, border: {top:{style:'medium', color:{rgb:'888888'}}, bottom:{style:'thin', color:{rgb:'CCCCCC'}}, left:{style:'thin', color:{rgb:'CCCCCC'}}, right:{style:'thin', color:{rgb:'CCCCCC'}}}, alignment: {horizontal:'right'}, numFmt: numFmt },
      total:      { font: {bold:true, sz:11, color:{rgb:'1A3E72'}}, fill: {fgColor:{rgb:'C5D3E8'}}, border: borderThick },
      totalNum:   { font: {bold:true, sz:11, color:{rgb:'1A3E72'}}, fill: {fgColor:{rgb:'C5D3E8'}}, border: borderThick, alignment: {horizontal:'right'}, numFmt: numFmt },
      balanced:   { font: {bold:true, sz:11, color:{rgb:'155724'}}, fill: {fgColor:{rgb:'D4EDDA'}}, border: borderThin },
      balancedNum:{ font: {bold:true, sz:11, color:{rgb:'155724'}}, fill: {fgColor:{rgb:'D4EDDA'}}, border: borderThin, alignment: {horizontal:'right'}, numFmt: numFmt },
      unbalanced: { font: {bold:true, sz:11, color:{rgb:'721C24'}}, fill: {fgColor:{rgb:'F8D7DA'}}, border: borderThin },
      unbalancedNum:{ font: {bold:true, sz:11, color:{rgb:'721C24'}}, fill: {fgColor:{rgb:'F8D7DA'}}, border: borderThin, alignment: {horizontal:'right'}, numFmt: numFmt },
      empty:      {}
    };

    // Merge company name and title rows
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } }
    ];

    // Apply styles per row
    for (let r = 0; r < rows.length; r++) {
      let type = styles[r];
      if (type === 'empty') continue;

      // Col A (text)
      let cellA = XLSX.utils.encode_cell({ r, c: 0 });
      if (ws[cellA]) {
        ws[cellA].s = type === 'header' ? styleMap.header : styleMap[type] || {};
      }
      // Col B & C (numbers)
      for (let c = 1; c <= 2; c++) {
        let cellRef = XLSX.utils.encode_cell({ r, c });
        if (ws[cellRef]) {
          let numType = type === 'header' ? 'headerNum' : (type + 'Num');
          ws[cellRef].s = styleMap[numType] || styleMap[type + 'Num'] || styleMap.groupNum;
          if (typeof ws[cellRef].v === 'number') ws[cellRef].z = numFmt;
        }
      }
    }

    // Row heights
    ws['!rows'] = styles.map(s => ({ hpt: s === 'companyInfo' ? 28 : s === 'reportTitle' ? 24 : s === 'header' ? 24 : s === 'class' || s === 'total' ? 22 : s === 'detail' ? 16 : 18 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Bilanci');
    XLSX.writeFile(wb, 'Bilanci i Gjendjes.xlsx');
  }

  const print = () => {
    printRef.current.printPreview()
  }

  const headers = [
    { key: 'name', columnName: 'Pershkrimi' , type:"text" },
    { key: 'currentYear', columnName: searchParams.startDate && searchParams.endDate ? helper().formatDate(searchParams.startDate) + ' - ' + helper().formatDate(searchParams.endDate) : 'Viti Aktual' , type:"number" },
    { key: 'previousYear', columnName: searchParams.prevStartDate && searchParams.prevEndDate ? helper().formatDate(searchParams.prevStartDate) + ' - ' + helper().formatDate(searchParams.prevEndDate) : 'Viti Paraprak' , type:"number" }
  ];


  const data = (mData) =>{
    var dPrint = [];
    mData.forEach(e => {
      // Emri i klases kryesore (Pasurite, Detyrimet, Ekuiteti)
      dPrint.push({name: e.name, mainItem: true })
      if(e.subClasses){
        e.subClasses.forEach(sub => {
          dPrint.push({name: '  ' + sub?.name, mainItem: true })
          let group = sub?.groups;
            group.forEach(g => {
              dPrint.push({name: '    ' + g.name , currentYear: g.currentYearValue , previousYear: g.previousYearValue })
              g.groupsInfo.forEach(gr => {
                dPrint.push({name: '      ' + gr.accName , currentYear: gr.grValue , previousYear: gr.prevGrValue || 0 , listItem: true })
              });
            });

          dPrint.push({name: 'Totali ' +  sub.name  , currentYear: sub.currentYearValue , previousYear: sub.previousYearValue , mainItem: true })
        });
      }
      dPrint.push({name: 'TOTALI ' + e.name.toUpperCase() , currentYear: e.currentYearValue , previousYear: e.previousYearValue , mainItem: true })
  });

  // Detyrime + Ekuitet
  if(mData.length === 3){
    let liabPlusEquity = (mData[1]?.rawCurrentYearValue || 0) + (mData[2]?.rawCurrentYearValue || 0);
    let prevLiabPlusEquity = (mData[1]?.rawPreviousYearValue || 0) + (mData[2]?.rawPreviousYearValue || 0);
    dPrint.push({name: '' })
    dPrint.push({name: 'DETYRIMET + EKUITETI' , currentYear: helper().formatNumber(liabPlusEquity) , previousYear: helper().formatNumber(prevLiabPlusEquity) , mainItem: true })

    let diff = parseFloat(((mData[0]?.rawCurrentYearValue || 0) - liabPlusEquity).toFixed(2));
    let prevDiff = parseFloat(((mData[0]?.rawPreviousYearValue || 0) - prevLiabPlusEquity).toFixed(2));
    dPrint.push({name: 'DIFERENCA' , currentYear: helper().formatNumber(diff) , previousYear: helper().formatNumber(prevDiff) , mainItem: true })
  }

  setDataForPrint(dPrint)
  }


  const formatData = function (response) {

    let formatedData = [];
    // Balance sheet main classes  =  1 ASSETS - Pasurit  2 LIABILITIES - detyrimet and 3 EQUITY - Ekuiteti
    let mainClasses = [
      { id: '1', name: 'Pasurite' },
      { id: '2', name: 'Detyrimet' },
      { id: '3', name: 'Ekuiteti' }

    ]

    mainClasses.forEach((m) => {
      let mainClassData = response.filter(i => i.classId.toString().startsWith(m.id));

      let mainClasse = { name: m.name };
      let isDebit = m.id === '1'; // Only Assets (class 1) have debit nature; Liabilities (2) and Equity (3) are credit nature

      let subClassIds = mainClassData.map(function (ii) { return ii.classId });
      let uniqueSubClassIds = [...new Set(subClassIds)];

      let currentYearValue = mainClassData.map(i => isDebit ? i.debits - i.credits : i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
      mainClasse.rawCurrentYearValue = currentYearValue;
      mainClasse.currentYearValue = helper().formatNumber(currentYearValue);

      mainClasse.rawPreviousYearValue = 0;
      mainClasse.previousYearValue = helper().formatNumber(0);

      mainClasse.subClasses = [];

      uniqueSubClassIds.forEach(subId => {
        let subClassObj = mainClassData.find(i => i.classId === subId);

        let subClass = { name: subClassObj.className };
        mainClasse.subClasses.push(subClass);
        let subClassData = mainClassData.filter((ii) => ii.classId === subId);

        let subClassCurrentYearValue = subClassData.map(i => isDebit ? i.debits - i.credits : i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
        subClass.currentYearValue = helper().formatNumber(subClassCurrentYearValue);

        subClass.previousYearValue = helper().formatNumber(0);

        //groups
        subClass.groups = [];
        let groupsIds = subClassData.map(function (ii) { return ii.groupId });
        let uniqueGroupsIds = [...new Set(groupsIds)];

        uniqueGroupsIds.forEach(groupId => {
          // console.log(groupId)
          var groupInfo = [];
          var groupedDifferences = [];
          let groupObj = subClassData.find(i => i.groupId === groupId);
          let groupData = subClassData.filter((ii) => ii.groupId === groupId);
          // console.log(groupObj)
          // console.log(groupData)

          let group = { name: groupObj.groupName };

          let groupCurrentYearValue = groupData.map(i => isDebit ? i.debits - i.credits : i.credits - i.debits).reduce((partialSum, a) => partialSum + a, 0);
          group.currentYearValue = helper().formatNumber(groupCurrentYearValue);

          group.previousYearValue = helper().formatNumber(0);

          groupData.forEach(item => {
            const { accName, accountId, debits, credits } = item;
            let diff = isDebit ? debits - credits : credits - debits;
            if (groupedDifferences[accountId] === undefined) {
              groupedDifferences[accountId] = diff;
            } else {
              groupedDifferences[accountId] += diff;
            }
          });
          
          const result = Object.keys(groupedDifferences).map(accountId => ({
            accName: groupData.find(item => item.accountId === parseInt(accountId)).accName,
            accountId: parseInt(accountId),
            grValue: groupedDifferences[accountId],
          }));

          group.groupsInfo = result;

          subClass.groups.push(group);
        });


      });


      // let groups = [];
      // subClassesData.forEach(subClass => {
      //   let subClasse = mainClassData.map(p=> {subClassName: p.groupName});
      //groups = subClass.map(g=> {groupName: g.accountName});
      //subClasses.groups = groups;
      //});
      //mainClass.subClass = subClasses;

      formatedData.push(mainClasse);
    });

    return formatedData;
  }

  const getDates = () => {

    let eDate = new Date();
    let sDate = new Date(eDate.getFullYear(),0,1,1); 

    setSearchParams({ ...searchParams, startDate: sDate, endDate: eDate});
    
    getGeneralBookWithDetails(sDate, eDate, 0, 0);

  };
 

  const getGeneralBookWithDetails = (startDate, endDate, branchId, projectId) => {

    if (!projectId) {
      projectId = 0;
    }

    let strStartDate = helper().formatDate(startDate,'MM-dd-yyyy');
    let strEndDate = helper().formatDate(endDate,'MM-dd-yyyy') + " 23:59:59";

    // Previous year dates
    let pStartDate = new Date(new Date(endDate).getFullYear() - 1, 0, 1);
    let month = new Date(endDate).getMonth();
    let day = new Date(endDate).getDate();
    let pEndDate = new Date(new Date(endDate).getFullYear() - 1, month, day);
    let strPrevStartDate = helper().formatDate(pStartDate,'MM-dd-yyyy');
    let strPrevEndDate = helper().formatDate(pEndDate,'MM-dd-yyyy') + " 23:59:59";

    setShowProgress(true);

    var params = `&startDate=${strStartDate}&endDate=${strEndDate}&branchId=${branchId}&projectId=${projectId}`;
    var prevParams = `&startDate=${strPrevStartDate}&endDate=${strPrevEndDate}&branchId=${branchId}&projectId=${projectId}`;

    // Fetch current year and previous year in parallel
    Promise.all([
      apiService().query('fnGeneralBookWithDetails', params),
      apiService().query('fnGeneralBookWithDetails', prevParams)
    ]).then(([response, prevResponse]) => {
      if (response.success) {
        let formatedData = formatData(response.data);
        let incData = parseFloat(incFormat(response.data).at(-1).currentValue) || 0;

        // Previous year data
        let prevIncData = 0;
        if (prevResponse.success && prevResponse.data.length > 0) {
          let prevFormatedData = formatData(prevResponse.data);
          prevIncData = parseFloat(incFormat(prevResponse.data).at(-1).currentValue) || 0;

          // Merge previous year values into current formatedData
          formatedData.forEach((mainClass, idx) => {
            let prevMain = prevFormatedData[idx];
            if (prevMain) {
              mainClass.rawPreviousYearValue = prevMain.rawCurrentYearValue || 0;
              mainClass.previousYearValue = helper().formatNumber(mainClass.rawPreviousYearValue);

              // Merge subclass previous year values
              mainClass.subClasses.forEach(sub => {
                let prevSub = prevMain.subClasses?.find(ps => ps.name === sub.name);
                if (prevSub) {
                  sub.previousYearValue = prevSub.currentYearValue;
                  sub.groups.forEach(group => {
                    let prevGroup = prevSub.groups?.find(pg => pg.name === group.name);
                    if (prevGroup) {
                      group.previousYearValue = prevGroup.currentYearValue;
                      // Merge account-level details
                      group.groupsInfo?.forEach(acc => {
                        let prevAcc = prevGroup.groupsInfo?.find(pa => pa.accountId === acc.accountId);
                        if (prevAcc) {
                          acc.prevGrValue = prevAcc.grValue;
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }

        // Automatically include current period net income in Equity (class 3)
        if (formatedData[2]) {
          let equity = formatedData[2];
          if (incData !== 0 || prevIncData !== 0) {
            equity.subClasses.push({
              name: "Fitimi neto",
              currentYearValue: helper().formatNumber(incData),
              previousYearValue: helper().formatNumber(prevIncData),
              groups: [{
                name: "Fitimi neto" + " (" + "Pasqyra e te Ardhurave" + ")",
                currentYearValue: helper().formatNumber(incData),
                previousYearValue: helper().formatNumber(prevIncData),
                groupsInfo: []
              }]
            });
          }
          equity.rawCurrentYearValue = (equity.rawCurrentYearValue || 0) + incData;
          equity.currentYearValue = helper().formatNumber(equity.rawCurrentYearValue);
          equity.rawPreviousYearValue = (equity.rawPreviousYearValue || 0) + prevIncData;
          equity.previousYearValue = helper().formatNumber(equity.rawPreviousYearValue);
        }

        setSearchParams({ ...searchParams, startDate: startDate, endDate: endDate, prevStartDate: pStartDate, prevEndDate: pEndDate});

        setMainData(formatedData);
        data(formatedData);
        setShowProgress(false);

      } else {
        console.log('Error:' + response.errorMessage);
        setShowProgress(false);
      }
    });
  };

  
  const getProjects = () => {
    
    apiService()
      .query("getProjects").then((response) => {
        if (response.success) {
          let data = response.data;
         
         

          let firstItem = { id: null, name: "Te gjitha projektet" };

          data.unshift(firstItem);

          let options = data.map((item, index) => ({
            value: item.id,
            label: item.name
          }));

          setProjects(options);

        } else {
          alert("Error: getting Projects" + response.errorMessage);
        }
      });
  };

  const getBranches = () => {
   
    apiService()
      .get("Branches").then((response) => {
        if (response.success) {
          
          let data = response.data;

          let firstItem = { id: null, name: "Te gjitha deget" };
          data.unshift(firstItem);

          let options = data.map((item, index) => ({
            value: item.id,
            label: item.name
          }));

          setBranches(options);

        } else {
          alert("Error: getting branches" + response.errorMessage);
        }
      });
  };

  const selectChange = (e,  obj) =>{

    if(obj.name==='branches'){
      setSearchParams({...searchParams, branchId: e.value});
    }
    else if(obj.name==='projects'){
      setSearchParams({...searchParams, projectId: e.value});
    }

  }

  const onSearchClick = () => {

    let startDate = searchParams.startDate;
    let endDate = searchParams.endDate;

    if (searchParams.includeStartDate === false) {
      let year = new Date(endDate).getFullYear();
      startDate = `${year}-01-01 00:00:00`;
    } else if (searchParams.includeEndDate === false) {
      endDate = "2222-01-01";
    }

    if(searchParams.branchId === null){
      searchParams.branchId = 0;
    }

    getGeneralBookWithDetails(startDate, endDate, searchParams.branchId, searchParams.projectId)
  }

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#9e9e9e",
      minHeight: "28.59px",
      height: "28.59px",
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "28.59px",
      padding: "0 6px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28.59px",
    }),
  };

  const dateChange = (e) => {
    let selected = new Date(e.target.value);
    setStartDate(selected);
  }

  return (
    <div className="container-fluid px-2 mt-3">
      <Search back="#/reportsMap/1" printClick={print} excel={() => exportToExcel()}   />
      <ExcelExport data={filterPrintData.length ? filterPrintData : []} headers={headers} type={'other'} ref={excelExportRef} hideContent={true} />
      <Print data={filterPrintData.length ? filterPrintData : []} headers={headers.filter(header => header !== false)}  ref={printRef} query={searchObj} reportName="Bilanci i Gjendjes" />
      <div className="card shadow">
        <div className="card-header border-left-primary py-2"><h6 className="m-0 font-weight-bold text-primary text-center">Bilanci i Gjendjes</h6></div>
       {showProgress && 
            <div style={{position:'absolute',top:'10px', right:'40px', zIndex:1000, color:'#4E73DF', fontSize:18}}>Duke ngarkuar ...</div>
       }
      </div>

      <div className="card border-left-primary text-dark overflow-hidden  shadow  mt-1 pt-1 pb-3">
        <div className="container mt-1 ">         
          <div className="row">
            <div className="col-12 col-md-9 offset-md-1 mt-2">
              <div className="row no-gutters align-items-center">
                <div className="col row">
                  <div className="col-lg-3 mb-3 mb-md-0 pe-0 d-flex align-items-center">
                    {/* <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                              Data e fillimit
                            </label> */}
                    <div style={{ paddingRight: '3px', border:'1px solid #fff' }}>
                      <input type="checkbox" name="includeStartDate" checked={ searchParams.includeStartDate}  onChange={(e) => setSearchParams({...searchParams, includeStartDate: e.target.checked})} />
                    </div>
                    <div style={{ width: '95%' }}>
                      <MDBInput 
                        name="startDate"
                        disabled={!searchParams.includeStartDate}
                        className="form-control-sm active"
                        onChange={(e) => setSearchParams({ ...searchParams, startDate: new Date(e.target.value)})}
                        type="date"
                        label="Data e fillimit"
                        value={helper().isValidDate(searchParams.startDate)  ?  searchParams.startDate.toISOString().substring(0,10): ''}
                      />
                      {/* <input type="date" onChange={pula} value={startDate  ?  startDate.toISOString().substring(0,10): ''}></input> */}
                    </div>
                  </div>
                  <div className="col-lg-3 mb-3 mb-md-0 pe-0 d-flex align-items-center">
                    {/* <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                              Data e Mbarimit
                            </label> */}
                    <div style={{ paddingRight: '3px'}}>
                      <input type="checkbox" name="includeStartDate" checked={searchParams.includeEndDate} onChange={(e) => setSearchParams({ ...searchParams, includeEndDate: e.target.checked })} ></input>
                    </div>
                    <div style={{ width: '95%' }}>
                      <MDBInput
                        name="endDate"
                        disabled={!searchParams.includeEndDate}
                        className="form-control-sm active"
                        onChange={(e) => setSearchParams({ ...searchParams, endDate: new Date(e.target.value)})}
                        type="date"
                        label="Data e mbarimit"
                        value={helper().isValidDate(searchParams.endDate)  ?  searchParams.endDate.toISOString().substring(0,10): ''}
                      />
                    </div>
                  </div>
                  <div style={{ paddingTop: "2px" }} className="col-lg-3 mb-3 mb-md-0 pe-0 ">

                    <Select
                      name="branches"
                      placeholder="Degët"
                      styles={selectStyles}
                      options={branches}
                      onChange={(e, obj) => selectChange(e, obj)}
                      value={branches?.find(p => p.value === branches.id)}

                    />
                  </div>
                  <div style={{ paddingTop: "2px" }} className="col-lg-3 mb-3 mb-md-0 pe-0 ">

                    <Select
                      name="projects"
                      placeholder="Te gjitha projektet"
                      styles={selectStyles}
                      options={projects}
                      onChange={(e, obj) => selectChange(e, obj)}
                      value={projects?.find(p => p.value === projects.projectId)}

                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-1 col-12  d-flex flex-column align-items-center justify-content-center  text-center ">
            <label className="text-xs font-weight-bold text-primary  mb-0">
                            Shfaq detalet
                            </label>
            <Switch
                          name="withVat"                     
                          onColor="#86d3ff"
                          offColor="#000000"
                          onHandleColor="#000000"
                          className="text-light "
                          handleDiameter={25}
                          width={55}
                          height={20}
                          uncheckedIcon={<span style={{display:'flex', margin: '-4px 0 0 -4px'}}><p>Jo</p></span>}
                          checkedIcon={<span style={{display:'flex', margin: '-4px 0 0 -4px'}}><p>Po</p></span>}
                          padding="0px 0px"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          onChange={(e) => setIsPositive(e) }
                          checked={isPositive}
                      />
            </div>
            <div className="col-md-1 col-12 d-flex align-items-center justify-content-center mt-3 mt-md-1  justify-content-lg-end">
              <div>
                <a className="searchbutton" onClick={() => onSearchClick()}>
                  <i className="fas fa-search fa-2x text-dark"  />
                </a>
              </div>
            </div>
          </div>
          <div className="table-responsive mt-3 px-1">
            <table className="table table-sm table-bordered mb-0" style={{tableLayout:'fixed'}}>
              <thead>
                <tr style={{background:'#1b2a4a', color:'#fff'}}>
                  <th style={{width:'50%', padding:'8px 12px', fontSize:'13px'}}>Bilanci i gjendjes per periudhen</th>
                  <th style={{width:'25%', padding:'8px 12px', fontSize:'13px', textAlign:'right'}}>{searchParams.startDate? helper().formatDate(searchParams.startDate) : ''} - {searchParams.endDate? helper().formatDate(searchParams.endDate) : ''}</th>
                  <th style={{width:'25%', padding:'8px 12px', fontSize:'13px', textAlign:'right'}}>{searchParams.prevStartDate? helper().formatDate(searchParams.prevStartDate) : ''} - {searchParams.prevEndDate? helper().formatDate(searchParams.prevEndDate) : ''}</th>
                </tr>
              </thead>
              <tbody>
              {
                mainData.map((main, mIdx) => {
                  return <React.Fragment key={mIdx}>
                    {/* Klasa kryesore */}
                    <tr style={{background:'#d6e4f0'}}>
                      <td colSpan={3} style={{padding:'8px 12px', fontWeight:'bold', fontSize:'14px', color:'#1a3e72', borderTop:'2px solid #1b2a4a'}}>{main.name}</td>
                    </tr>
                    {
                      main.subClasses && main.subClasses.map((sub, sIdx) => {
                        return <React.Fragment key={sIdx}>
                          {/* Nen-klasa */}
                          <tr style={{background:'#e9edf5'}}>
                            <td style={{padding:'6px 12px 6px 20px', fontWeight:'bold', fontSize:'13px', color:'#222'}}>{sub.name}</td>
                            <td></td>
                            <td></td>
                          </tr>
                          {/* Grupet */}
                          {
                            sub.groups.map((group, gIdx) => {
                              return <React.Fragment key={gIdx}>
                                <tr>
                                  <td style={{padding:'4px 12px 4px 32px', fontSize:'12px', color:'#111'}}>{group.name}</td>
                                  <td style={{textAlign:'right', padding:'4px 12px', fontSize:'12px', fontWeight:'700', color:'#111'}}>{group.currentYearValue}</td>
                                  <td style={{textAlign:'right', padding:'4px 12px', fontSize:'12px', fontWeight:'700', color:'#111'}}>{group.previousYearValue}</td>
                                </tr>
                                {/* Detalet e llogarive */}
                                {isPositive && group?.groupsInfo?.length > 0 && group.groupsInfo.map((gr, grIdx) => (
                                  <tr key={grIdx} style={{background:'#fafbfd'}}>
                                    <td style={{padding:'2px 12px 2px 52px', fontSize:'11px', color:'#777', fontStyle:'italic'}}>{gr.accName}</td>
                                    <td style={{textAlign:'right', padding:'2px 12px', fontSize:'11px', color:'#777'}}>{helper().formatNumber(gr.grValue)}</td>
                                    <td style={{textAlign:'right', padding:'2px 12px', fontSize:'11px', color:'#777'}}>{helper().formatNumber(gr.prevGrValue || 0)}</td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            })
                          }
                          {/* Totali i nen-klases */}
                          <tr style={{background:'#dce3f0', borderTop:'1px solid #888'}}>
                            <td style={{padding:'5px 12px 5px 20px', fontWeight:'bold', fontSize:'12px', color:'#111'}}>Totali {sub.name.toLowerCase()}</td>
                            <td style={{textAlign:'right', padding:'5px 12px', fontWeight:'bold', fontSize:'12px', color:'#111', borderTop:'1px solid #888'}}>{sub.currentYearValue}</td>
                            <td style={{textAlign:'right', padding:'5px 12px', fontWeight:'bold', fontSize:'12px', color:'#111', borderTop:'1px solid #888'}}>{sub.previousYearValue}</td>
                          </tr>
                        </React.Fragment>
                      })
                    }
                    {/* Totali i klases */}
                    <tr style={{background:'#c5d3e8', borderTop:'2px solid #1b2a4a'}}>
                      <td style={{padding:'7px 12px', fontWeight:'bold', fontSize:'13px', color:'#1a3e72'}}>TOTALI {main.name.toUpperCase()}</td>
                      <td style={{textAlign:'right', padding:'7px 12px', fontWeight:'bold', fontSize:'13px', color:'#1a3e72', borderTop:'2px solid #1b2a4a'}}>{main.currentYearValue}</td>
                      <td style={{textAlign:'right', padding:'7px 12px', fontWeight:'bold', fontSize:'13px', color:'#1a3e72', borderTop:'2px solid #1b2a4a'}}>{main.previousYearValue}</td>
                    </tr>
                  </React.Fragment>
                })
              }

              {mainData.length === 3 && (() => {
                const assets = mainData[0]?.rawCurrentYearValue || 0;
                const liabilities = mainData[1]?.rawCurrentYearValue || 0;
                const equity = mainData[2]?.rawCurrentYearValue || 0;
                const liabPlusEquity = liabilities + equity;
                const difference = parseFloat((assets - liabPlusEquity).toFixed(2));
                const isBalanced = Math.abs(difference) < 0.01;

                const prevAssets = mainData[0]?.rawPreviousYearValue || 0;
                const prevLiabilities = mainData[1]?.rawPreviousYearValue || 0;
                const prevEquity = mainData[2]?.rawPreviousYearValue || 0;
                const prevLiabPlusEquity = prevLiabilities + prevEquity;
                const prevDifference = parseFloat((prevAssets - prevLiabPlusEquity).toFixed(2));
                const prevIsBalanced = Math.abs(prevDifference) < 0.01;

                return <>
                  <tr style={{borderTop:'3px solid #333'}}>
                    <td style={{padding:'8px 12px', fontWeight:'bold', fontSize:'13px', color:'#333'}}>Detyrimet + Ekuiteti</td>
                    <td style={{textAlign:'right', padding:'8px 12px', fontWeight:'bold', fontSize:'13px'}}>{helper().formatNumber(liabPlusEquity)}</td>
                    <td style={{textAlign:'right', padding:'8px 12px', fontWeight:'bold', fontSize:'13px'}}>{helper().formatNumber(prevLiabPlusEquity)}</td>
                  </tr>
                  <tr style={{background: isBalanced ? '#d4edda' : '#f8d7da'}}>
                    <td style={{padding:'8px 12px', fontWeight:'bold', fontSize:'13px', color: isBalanced ? '#155724' : '#721c24'}}>
                      <i className={`fas ${isBalanced ? 'fa-check-circle' : 'fa-exclamation-triangle'} mr-2`}></i>
                      Diferenca
                    </td>
                    <td style={{textAlign:'right', padding:'8px 12px', fontWeight:'bold', fontSize:'13px', color: isBalanced ? '#155724' : '#721c24'}}>{helper().formatNumber(difference)}</td>
                    <td style={{textAlign:'right', padding:'8px 12px', fontWeight:'bold', fontSize:'13px', color: prevIsBalanced ? '#155724' : '#721c24'}}>{helper().formatNumber(prevDifference)}</td>
                  </tr>
                </>
              })()}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

  )
}

export default BalanceSheet;
